import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M15.23 2.53l-.35.35c-.39.385-.666.87-.8 1.4a8.01 8.01 0 105.64 5.63 3 3 0 001.4-.79l.35-.35A9.99 9.99 0 0112 22a10 10 0 113.23-19.47zM13.55 6.2L11.75 8a4 4 0 104.24 4.25l1.8-1.8a6 6 0 11-4.24-4.25zm5.83-4.11A1 1 0 0120 3v1h1a1 1 0 01.7 1.7l-2 2a1 1 0 01-.7.3h-1.59l-4.7 4.7a1 1 0 01-1.42-1.4L16 6.58V5a1 1 0 01.3-.7l2-2a1 1 0 011.08-.21z",
      fill: "#2d6ded"
    }
  )
), l = t;
export {
  l as default
};
